module.exports = __webpack_public_path__ + "assets/archive-1.80a1a08f.svg";